<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="预约信息"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}" autocomplete="off">
            <el-form-item label="特属专家姓名" prop="user_name" v-if="is_user_name">
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入特属专家姓名" maxlength="5"
                          @input="userNameCheck" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="特属专家姓名" prop="user_name" class="is-error" v-else>
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入特属专家姓名" maxlength="5"
                          @input="userNameCheck" autocomplete="off"
                          style="width: 100%;"></el-input>
                <div class="el-form-item__error">请输入2-5个字的中文姓名</div>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
                <el-input type="text" v-model="ruleForm.mobile" maxlength="11" placeholder="请输入手机号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码">
                <el-input type="text" v-model="ruleForm.idcard" maxlength="18" placeholder="请输入身份证号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="单位" prop="hospital_id">
                <el-select v-model="ruleForm.hospital_id" placeholder="请选择单位" style="width: 100%;">
                    <el-option
                        v-for="item in allHospital"
                        :key="item.id"
                        :label="item.hospital_nick_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="科室名称" prop="hospital_department_id">
                <el-select v-model="ruleForm.hospital_department_id" placeholder="请选择科室"
                           style="width: 100%;">
                    <el-option
                        v-for="item in hospitalDeparment "
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="职称" prop="doctor_title_id">
                <el-select v-model="ruleForm.doctor_title_id" placeholder="请选择职称"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allDoctorTitle "
                        :key="item.id"
                        :label="item.title_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="签约特属服务对象上限" prop="max_client">
                <el-input type="number" v-model="ruleForm.max_client" placeholder="请输入签约特属服务对象上限" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="运营负责公司" prop="company_id">
                <el-select @change="changeCompany" v-model="ruleForm.company_id" placeholder="请选择运营负责公司"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompany"
                        :key="item.id"
                        :label="item.company_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责部门">
                <el-select @change="changeDeparment" v-model="ruleForm.department_id"
                           placeholder="请选择运营负责部门"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompanyDeparment"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营负责组">
                <el-select v-model="ruleForm.group_id" @change="changeGroup" placeholder="请选择运营负责组"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompanyGroup"
                        :key="item.id"
                        :label="item.group_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="特属服务专员">
                <el-select v-model="ruleForm.operate_user_ids"
                           multiple
                           placeholder="请选择特属服务专员"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allGroupUser"
                        :key="item.id"
                        :label="item.user_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="简介">
                <el-input type="textarea" v-model="ruleForm.introduction" autosize placeholder="请输入简介" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="头像">
                <div class="avatar-uploader">
                    <label class="avatar-btn" for="uploads">
                        <img style=" width: 200px;height: 200px;" v-if="userAvaratImageUrl" :src="userAvaratImageUrl"
                             class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </label>
                </div>
                <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
            </el-form-item>
            <el-form-item label="关联专家库" prop="expert_id">
                <el-select v-model="ruleForm.expert_id" placeholder="请选择专家库"
                           clearable
                           style="width: 100%;">
                    <el-option
                        v-for="item in allExpertList "
                        :key="item.user_id"
                        :label="item.user_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>


        <el-dialog title="头像裁剪" :visible.sync="dialogVisible" append-to-body @close="closeDialog">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :autoCrop="true"
                        :fixed="true"
                        :fixedNumber="[1, 1]">
                    </vue-cropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <label class="el-button el-button--primary" for="suploads" style="margin-right: 10px;"><span>重新选择</span></label>
                <input type="file" id="suploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                <el-button type="primary" @click="uploadImg('blob')" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {VueCropper} from 'vue-cropper'
import {isMobile, userNameCheck} from "@/api/order";

export default {
    components: {
        VueCropper
    },
    created() {
        if (isMobile()) {
            this.form_width = '100%'
        }
        localStorage.setItem('prev_page', 'doctor_edit')
        this.user_id = this.$route.params.user_id || this.$route.query.user_id;
        let userData = getUserInfos();
        this.ruleForm.input_user_name = userData.user_name;
    },
    mounted() {
        this.createParams();
    },
    data() {
        return {
            dialogVisible: false,
            // 防止重复提交
            loading: false,
            previews: {},
            option: {
                img: '',             //裁剪图片的地址
            },
            user_id: '',
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            userAvaratImageUrl: '',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            allCompany: [],
            allCompanyDeparment: [],
            allCompanyGroup: [],
            allGroupUser: [],
            allHospital: [],
            allHospitalDeparment: [],
            hospitalDeparment: [],
            allDoctorTitle: [],
            allExpertList: [],
            ruleForm: {
                user_name: "",
                mobile: "",
                idcard: "",
                hospital_id: "",
                hospital_department_id: "",
                doctor_title_id: "",
                max_client: '',
                status: 1,
                user_avatar: "",
                introduction: "",
                expert_id: '',
                company_id: '',
                department_id: '',
                group_id: '',
                operate_user_id: '',
                operate_user_ids: [],
            },
            rules: {
                user_name: [
                    {required: true, message: "请输入特属专家姓名", trigger: "blur"},
                ],
                mobile: [
                    {required: true, message: "请输入手机号码", trigger: "blur"},
                ],
                idcard: [
                    {required: true, message: "请输入身份证号码", trigger: "blur"},
                ],
                hospital_id: [
                    {required: true, message: "请选择单位", trigger: "blur"},
                ],
                hospital_department_id: [
                    {required: true, message: "请选择科室", trigger: "blur"},
                ],
                doctor_title_id: [
                    {required: true, message: "请选择职称", trigger: "blur"},
                ],
                company_id: [
                    {required: true, message: "请选择所属公司", trigger: "blur"},
                ],
                department_id: [
                    {required: true, message: "请选择所属部门", trigger: "blur"},
                ],
                group_id: [
                    {required: true, message: "请选择所属组", trigger: "blur"},
                ],
                max_client: [
                    {required: true, message: "请输入签约特属服务对象上限", trigger: "blur"},
                ],
                status: [
                    {required: true, message: "请选择状态", trigger: "blur"},
                ],
                user_avatar: [
                    {required: true, message: "请选择头像", trigger: "blur"},
                ],
            },
            is_submit: false,
            is_user_name: true, // 用户名输入是否正确
            form_width: "40%",
        };
    },
    methods: {
        // 用户名中文验证
        userNameCheck(e) {
            if (e) {
                this.is_user_name = userNameCheck(e)
            } else {
                this.is_user_name = true
            }
        },
        // 所有咨询者，特属专家
        createParams() {
            let params = {
                servername: 'Ruyi_AdminNewOperateServices',
                method: 'createParams',
                params: {
                    user_id: this.user_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompany = res.data.data.company;
                this.allHospital = res.data.data.hospital;
                this.allDoctorTitle = res.data.data.doctor_title;
                this.allExpertList = res.data.data.expert;
                this.hospitalDeparment = res.data.data.hospital_department

                this.doctorDetail();
            });
        },

        doctorDetail() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'doctorDetail',
                params: {
                    user_id: this.user_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.ruleForm.user_name = res.data.data.user_name;
                this.ruleForm.mobile = res.data.data.mobile;
                this.ruleForm.idcard = res.data.data.idcard;
                this.ruleForm.hospital_id = res.data.data.hospital_id;
                // this.changeHospital();
                this.ruleForm.hospital_department_id = res.data.data.hospital_department_id;
                this.ruleForm.doctor_title_id = res.data.data.doctor_title_id;
                this.ruleForm.max_client = res.data.data.max_client;
                this.ruleForm.status = parseInt(res.data.data.status);
                if (res.data.data.user_avatar) {
                    this.ruleForm.user_avatar = res.data.data.user_avatar;
                    this.userAvaratImageUrl = this.imgUrl + res.data.data.user_avatar;
                }
                this.ruleForm.introduction = res.data.data.introduction;
                this.ruleForm.expert_id = res.data.data.expert_id;
                this.ruleForm.company_id = res.data.data.company_id;
                if (res.data.data.operate_user_id > 0) {
                    this.ruleForm.operate_user_id = res.data.data.operate_user_id;
                    this.ruleForm.operate_user_ids.push(res.data.data.operate_user_id)
                } else {
                    this.ruleForm.operate_user_id = '';
                }
                this.changeCompany();
                this.ruleForm.department_id = res.data.data.department_id;
                this.changeDeparment();
                this.ruleForm.group_id = res.data.data.group_id;
                this.changeGroup();
                if (res.data.data.other_operate_users && res.data.data.other_operate_users.length > 0) {
                    for (let i = 0; i < res.data.data.other_operate_users.length; i++) {
                        this.ruleForm.operate_user_ids.push(res.data.data.other_operate_users[i])
                    }
                }
            });
        },

        // 返回上一页
        goBack() {
            window.history.go(-1)
            return;
        },

        // 提交表单
        submitForm(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AdminExpertServices',
                        'method': 'edit',
                        'params': {
                            user_id: this.user_id,
                            user_name: this.ruleForm.user_name,
                            mobile: this.ruleForm.mobile,
                            idcard: this.ruleForm.idcard,
                            hospital_id: this.ruleForm.hospital_id,
                            hospital_department_id: this.ruleForm.hospital_department_id,
                            doctor_title_id: this.ruleForm.doctor_title_id,
                            max_client: this.ruleForm.max_client,
                            status: this.ruleForm.status,
                            introduction: this.ruleForm.introduction,
                            user_avatar: this.ruleForm.user_avatar,
                            company_id: this.ruleForm.company_id,
                            department_id: this.ruleForm.department_id,
                            group_id: this.ruleForm.group_id,
                            expert_id: this.ruleForm.expert_id,
                            // operate_user_id: this.ruleForm.operate_user_id,
                            operate_user_ids: this.ruleForm.operate_user_ids,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '编辑成功',
                            duration: 1500,
                            onClose: function () {
                                // window.history.go(-1);
                                _that.is_submit = false;
                                _that.$router.push({
                                    name: "doctorList",
                                    params: {}
                                });
                            }
                        });
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },


        changeCompany() {
            this.ruleForm.department_id = '';
            this.ruleForm.group_id = '';
            this.getAllDeparment();
        },
        changeDeparment() {
            this.ruleForm.group_id = '';
            this.getAllCompanyGroup();
        },
        getAllDeparment() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyDeparment',
                params: {
                    company_id: this.ruleForm.company_id,
                    status: 1
                }
            };
            this.allCompanyDeparment = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompanyDeparment = res.data.data;
            });
        },

        getAllCompanyGroup() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyGroup',
                params: {
                    company_id: this.ruleForm.company_id,
                    department_id: this.ruleForm.department_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompanyGroup = res.data.data;
            });
        },
        // 获取组成员
        changeGroup() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllGroupUser',
                params: {
                    company_id: this.ruleForm.company_id,
                    department_id: this.ruleForm.department_id,
                    group_id: this.ruleForm.group_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allGroupUser = res.data.data;
            });
        },
        //选择图片
        selectImg(e) {
            let file = e.target.files[0]

            if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                this.$message({
                    message: '图片类型要求：jpeg、jpg、png',
                    type: "error"
                });
                return false
            }
            //转化为blob
            let reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                this.option.img = data
                this.dialogVisible = true;
            }
            //转化为base64
            reader.readAsDataURL(file)
        },
        //上传图片
        uploadImg(type) {
            let _this = this;
            if (type === 'blob') {
                //获取截图的blob数据
                this.$refs.cropper.getCropBlob(async (data) => {

                    let formData = new FormData();
                    formData.append('file', data, ".jpg")

                    await _this.$api.avatar_upload_file(formData).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code == 0) {
                            _this.ruleForm.user_avatar = res.data.data;
                            _this.userAvaratImageUrl = this.imgUrl + res.data.data;
                            _this.dialogVisible = false;
                        } else {
                            _this.$message({
                                type: "error",
                                message: res.data.msg,
                            });
                        }
                    })

                })
            }
        },
        // 关闭对话框清除之前选择的文件
        closeDialog() {
            document.getElementById('uploads').value = ''
            document.getElementById('suploads').value = ''
        }
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.cropper-content {
    .cropper {
        width: auto;
        height: 300px;
    }
}

.avatar-btn, .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-btn {
    display: inline-block;
    text-align: center;
}

.avatar-btn, .avatar-uploader .el-upload:hover {
    border-color: #d9d9d9;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar-btn {
    width: 200px;
    height: 200px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
